import React from 'react';
import { Modal, Button } from 'flowbite-react';
import { HiCheckCircle } from 'react-icons/hi';
import { FcGoogle } from 'react-icons/fc';
import { FaApple } from 'react-icons/fa';

/**
 * Modal to prompt users to complete OAuth after successful subscription payment
 * Shows when user returns but hasn't linked their Google/Apple account
 */
const PendingOAuthModal = ({ show, onClose, onGoogleAuth, onAppleAuth }) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      size="md"
      dismissible={false}
      popup
    >
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          {/* Success Icon */}
          <HiCheckCircle className="mx-auto mb-4 h-14 w-14 text-green-500" />

          {/* Title */}
          <h3 className="mb-3 text-xl font-semibold text-gray-900 dark:text-white">
            Welcome Back!
          </h3>

          {/* Message */}
          <p className="mb-6 text-base text-gray-500 dark:text-gray-400">
            You have an active subscription. Complete your registration to access your account and manage your eSIMs.
          </p>

          {/* OAuth Buttons */}
          <div className="space-y-3">
            {/* Google Sign In */}
            <Button
              onClick={onGoogleAuth}
              className="w-full"
              color="light"
            >
              <FcGoogle className="mr-2 h-5 w-5" />
              Continue with Google
            </Button>

            {/* Apple Sign In */}
            <Button
              onClick={onAppleAuth}
              className="w-full"
              color="dark"
            >
              <FaApple className="mr-2 h-5 w-5" />
              Continue with Apple
            </Button>
          </div>

          {/* Footer Note */}
          <p className="mt-6 text-xs text-gray-400 dark:text-gray-500">
            Your subscription is already active. This step links your account for easy access.
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PendingOAuthModal;
